import { Action, configureStore, getDefaultMiddleware, ThunkAction } from "@reduxjs/toolkit";
import { companyReducer } from "common/_redux/company/reducer";
import { ContractReducer } from "common/_redux/contract/reducer";
import { paymentsReducer } from "common/_redux/payments/reducer";
import { praticaReducer } from "common/_redux/pratica/reducer";
import { serviceReducer } from "common/_redux/service/reducer";
import { subjectReducer } from "common/_redux/subject/reducer";
import { authReducer } from "core/auth/_redux/reducer";
import { invitationReducer } from "pages/invitation/_redux/reducer";
import { ReopenReducer } from "pages/reopened/_redux/reducer";
import { layoutReducer } from "../../layout/_redux/reducers";
import { commonReducer } from "./reducers";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		common: commonReducer,
		layoutReducer: layoutReducer,
		subject: subjectReducer,
		invitation: invitationReducer,
		company: companyReducer,
		pratica: praticaReducer,
		service: serviceReducer,
		payments: paymentsReducer,
		contract: ContractReducer,
		reopen: ReopenReducer,
	},
	middleware: getDefaultMiddleware({
		serializableCheck: false,
	}),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;

export interface ThunkApiConfig {
	state: RootState;
}
